<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

export default {
  name: 'App',
  created () {
  }
}

</script>

<style lang="scss">
@import '../static/ist-style.css.scss'
</style>



// WEBPACK FOOTER //
// src/App.vue